import React from "react";

export const CARStrip = () => (
  <div
    data-testid="car-strip"
    className="px-6 py-2 bg-stone-50/70 border-b border-stone-200 flex items-center gap-6 flex-wrap text-[11px] text-stone-700"
  >
    <div className="flex items-center gap-1.5">
      <span className="font-mono text-[10px] text-stone-400 uppercase tracking-[0.18em]">CAR</span>
      <span>
        <strong className="text-stone-900">Custody</strong> controls the evidence ·{" "}
        <strong className="text-stone-900">Authority</strong> governs the action ·{" "}
        <strong className="text-stone-900">Receipts</strong> prove what happened.
      </span>
    </div>
    <div className="text-stone-500 hidden lg:block">
      KATLAS records the governed action — not a copy of everyone's private data. Evidence stays at source.
    </div>
  </div>
);
